module.exports = require('./modules/helpers/makeHref');



//////////////////
// WEBPACK FOOTER
// ./~/react-router/makeHref.js
// module id = 218
// module chunks = 0